import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const useScrollRestoration = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const scrollYRef = useRef(0);

  useEffect(() => {
    // Clear all saved scroll positions before page refresh so reload always starts from top
    const clearOnReload = () => {
      for (const k of Object.keys(sessionStorage).filter((k) => k.startsWith('scroll-'))) {
        sessionStorage.removeItem(k);
      }
    };
    window.addEventListener('beforeunload', clearOnReload);
    return () => window.removeEventListener('beforeunload', clearOnReload);
  }, []);

  useEffect(() => {
    const updateScroll = () => { scrollYRef.current = window.scrollY; };
    window.addEventListener('scroll', updateScroll, { passive: true });
    return () => window.removeEventListener('scroll', updateScroll);
  }, []);

  useEffect(() => {
    const key = `scroll-${location.pathname}`;

    if (navigationType === 'POP') {
      // Back/forward navigation — restore saved position
      const saved = sessionStorage.getItem(key);
      if (saved) {
        setTimeout(() => window.scrollTo({ top: +saved, behavior: 'instant' }), 50);
      } else {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }
    } else {
      // Fresh navigation (link/button click) — always start from top
      sessionStorage.removeItem(key);
      window.scrollTo({ top: 0, behavior: 'instant' });
    }

    return () => {
      sessionStorage.setItem(key, String(scrollYRef.current));
    };
  }, [location.pathname, navigationType]);
};

export default useScrollRestoration;
